import {defineStore} from "pinia";
import {Component, shallowRef} from "vue";
import LoginForm from "../components/SignUpForm.vue"
import SignUpForm from "../components/LoginForm.vue"
import RecoveryForm from "../components/RecoveryForm.vue"

export type RootState = {
    visible: boolean;
    activeForm: Component,
};

export const useAuthPopup = defineStore({
    id: "authPopup",
    state: () => {
        return {
            visible: false,
            activeForm: shallowRef(LoginForm),
        } as RootState
    },

    actions: {
        openLoginForm() {
            this.activeForm = LoginForm
            this.visible = true
        },
        openSignForm() {
            this.activeForm = SignUpForm
            this.visible = true
        },
        openRecoveryForm() {
            this.activeForm = RecoveryForm
            this.visible = true
        },
    },
})